import React from 'react';
import {
  isLegacyCandidateStoryContent,
  parseStoryContent,
} from '../../helpers';
import LegacyStory from './LegacyStory';
import StructuredStory from './StructuredStory';

interface StoryTextProps {
  content: string;
}

const StoryText: React.FC<StoryTextProps> = ({ content }) => {
  if (isLegacyCandidateStoryContent(content)) {
    return <LegacyStory content={content} />;
  }

  const parsedContent = parseStoryContent(content);
  return <StructuredStory content={parsedContent} />;
};

export default StoryText;
